


















































































import { Component, Vue } from 'vue-property-decorator';

@Component({
    computed: {
        getAppName() {
            return this.$route.query.app

        }
    },
})
export default class TOSGPS extends Vue {}
